import { Editor } from "primereact/editor";
import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { Chips } from "primereact/chips";
import { ClientsList, ProjectAddUpdate } from "./Service/TaskService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../App";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useDispatch } from "react-redux";
import { setRecentProjectData } from "../../../Services/Redux/DataTransferToAnother";

const AddProject = ({ isOpen, onClose, onSave, editProjectDetails }) => {
  const initialForm = {
    id: "",
    name: "",
    type: "",
    start: "",
    end: "",
    clientName: "",
    manager: "",
    IsPublic: true,
    // clientLocation: "",
    // clientContact: "",
    // clientEmail: "",
    // clientPhone: "",
    // clientWeb: "",
    desc: "",
    team: [],
  };

  const [projectform, setProjectForm] = useState(initialForm);

  const [showClientDetails, setShowClientDetails] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadingCount, setLoadingCount] = useState(0);
  const startLoading = () => setLoadingCount(prev => prev + 1);
  const stopLoading = () => setLoadingCount(prev => Math.max(0, prev - 1));
  const isAnythingLoading = loadingCount > 0;
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [employeeList, setEmployeList] = useState([]);
  const [showEmployee, setShowEmployee] = useState(false);
  // No longer need selectedEmployees state for auto-add/remove
  const [clientList, setClientList] = useState([]);
  const [projectTypeList, setProjectTypeList] = useState([]);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showAll, setShowAll] = useState(false);
  const dispatch = useDispatch();
  const visibleMembers = showAll
    ? projectform.team
    : projectform.team?.slice(0, 3);

  useEffect(() => {
    fetchEmployeeIdData();
    getClientList();
    getProjectTypeCategory();
    GetMasterSystemAlertList();
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    if (editProjectDetails && isOpen) {
      const projectMembers = editProjectDetails?.ProjectMemberList?.map((pm) => ({
        Id: pm?.EmpId,
        FullName: pm?.EmployeeName,
      }));
      const formData = {
        id: editProjectDetails?.Id,
        name: editProjectDetails?.Name || "",
        type: editProjectDetails?.ProjectTypeId || 0,
        start: editProjectDetails?.StartDate?.split(" ")[0] || "",
        end:
          editProjectDetails?.EndDate === "1900-01-01 05:30:00"
            ? ""
            : editProjectDetails?.EndDate?.split(" ")[0],
        clientName: editProjectDetails?.ClientId || 0,
        manager: editProjectDetails?.ManagerId || 0,
        desc: editProjectDetails?.Desc || "",
        IsPublic: editProjectDetails?.IsPublic || false,
        team: projectMembers,
      };
      fetchEmployeeIdData();
      setProjectForm(formData);
    } else {
      setProjectForm(initialForm);
    }
  }, [editProjectDetails, isOpen]);

  async function fetchEmployeeIdData() {
    startLoading();
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    // setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeList(employeesList?.Data?.map((emp) => {
        return {
          Id: emp?.Id,
          FullName: emp?.FullName,
          ProfileImage: emp?.ProfileImage
        }
      }));
    } catch (error) {
      toster.current.error(error.employeesList.Data?.Message || "somthing went wrong");

    } finally {
      stopLoading(); // ✅
    }

  }

  async function getProjectTypeCategory() {
    startLoading();
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "ProjectType",
    };
    try {
      const data = await GetMasterTypeData(params);
      setProjectTypeList(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading(); // ✅
    }
  }

  async function getClientList() {
    startLoading();
    const params = {
      Id: 0,
      Guid: "",
      Search: "",
      PageNumber: 1,
      PageSize: 10000,
      CountryId: "",
      TotalProjects: 0,
      Status: 0,
      SortBy: "",
      SortOrder: ""
    };
    try {
      const response = await ClientsList(params);
      setClientList(response?.Data);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading();
    }
  }

  const handleChange = (key, value) => {
    setProjectForm({ ...projectform, [key]: value });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!projectform.name.trim()) {
      newErrors.name = "Project name is required";
    }

    if (!projectform.type) {
      newErrors.type = "Project type is required";
    }

    if (!projectform.clientName) {
      newErrors.clientName = "Client is required";
    }

    if (projectform.start && projectform.end) {
      if (new Date(projectform.end) < new Date(projectform.start)) {
        newErrors.end = "End date cannot be before start date";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    startLoading();
    const teamMembers = projectform?.team?.map((t) => { return t?.Id })
    const params = {
      Id: projectform?.id || 0,
      ClientId: Number(projectform?.clientName),
      ProjectTypeId: Number(projectform?.type),
      Name: projectform?.name,
      Desc: projectform?.desc,
      StartDate: projectform?.start,
      EndDate: projectform?.end || '',
      ProjectStatusId: editProjectDetails?.ProjectStatusId ?? 101,
      ManagerId: Number(projectform?.manager),
      IsPublic: projectform?.IsPublic,
      TeamMembers: teamMembers?.toString() || ''
    };

    try {
      // if (editProjectDetails?.Id > 0) {
      //   setShowLoader(true);
      // }
      const response = await ProjectAddUpdate(params);
      if (response?.StatusCode === 2000) {
        onSave && onSave(response.Data);

        if (projectform?.id > 0) {
          GetMasterSystemAlertList("Project_Update", 0);
        } else {
          GetMasterSystemAlertList("Project_Add", 0);
        }
        dispatch(setRecentProjectData('Project_Updated'));
        onClose('success');
      } else {
        toster.current.error(response?.Message || "Something went wrong");
      }

    } catch (err) {
      console.error(err);
      // alert("API error");
    } finally {
      stopLoading();
    }
  };

  //   const toggleClientExpand = () => {
  //     setShowClientDetails(!showClientDetails);
  //   };

  //   const toggleMemberDD = () => {
  //     setShowMemberDD(!showMemberDD);
  //   };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };
  if (!isOpen) return null;

  // Add or remove a member instantly when checkbox is toggled
  const toggleMember = (employee, checked) => {
    if (checked) {
      // Add if not already present
      if (!projectform?.team?.find((t) => t.Id === employee.Id)) {
        setProjectForm((prev) => ({
          ...prev,
          team: [...(prev.team || []), employee],
        }));
      }
    } else {
      // Remove if present
      setProjectForm((prev) => ({
        ...prev,
        team: prev.team.filter((t) => t.Id !== employee.Id),
      }));
    }
  };

  const removeMember = (id) => {
    setProjectForm({
      ...projectform,
      team: projectform.team.filter((t) => t.Id !== id),
    });
  };

  const headerTemplate = (
    <span className="ql-formats0">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  return (
    <div className="mo-tm" onClick={handleOverlayClick}>
      <div className="mb" style={{ width: "700px" }}>
        {/* Header */}
        <div className="mh">
          <div
            style={{
              width: 28,
              height: 28,
              background: "var(--brand-soft)",
              borderRadius: 7,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--brand)",
            }}
          >
            <i className="fa-solid fa-folder-plus"></i>
          </div>
          <h5>Project Details</h5>
          <button className="btn btn-ghost btn-icon mla" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* Body */}
        <div className="mbody">
          {/* Project Name */}
          <div style={{ marginBottom: 14 }}>
            <label className="fl">
              Project Name <i className="inValidError">*</i>
            </label>
            <input
              className="fc"
              value={projectform.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            {errors.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </div>

          {/* Type, Start, End */}
          <div className="frow fc3 task-form-group">
            <div className="">
              <label className="fl">
                Project Type <i className="inValidError">*</i>
              </label>
              <select
                className="fc"
                value={projectform.type}
                onChange={(e) => handleChange("type", e.target.value)}
              >
                <option value="">Select</option>
                {projectTypeList.map((p) => (
                  <option value={p.Id}>{p?.Name}</option>
                ))}
              </select>
              {errors.type && (
                <div className="invalid-feedback">{errors.type}</div>
              )}
            </div>

            <div>
              <label className="fl">Start Date</label>
              <input
                type="date"
                className="fc"
                value={projectform.start}
                onChange={(e) => handleChange("start", e.target.value)}
                onClick={(e) =>
                  e.target.showPicker &&
                  e.target.showPicker()
                }
              />
              {errors.start && (
                <div className="invalid-feedback">{errors.start}</div>
              )}
            </div>

            <div>
              <label className="fl">End Date</label>
              <input
                type="date"
                className="fc"
                value={projectform.end}
                onChange={(e) => handleChange("end", e.target.value)}
                onClick={(e) =>
                  e.target.showPicker &&
                  e.target.showPicker()
                }
              />
              {errors.end && (
                <div className="invalid-feedback">{errors.end}</div>
              )}
            </div>
          </div>

          {/* Client + Manager */}
          <div className="frow fc2 task-form-group">
            <div>
              <label className="fl d-flex justify-content-between">
                <span>Client Name <i className="inValidError">*</i></span>
                <Link to="/Project/Clients"><i className="fa-solid fa-plus" ></i> Add Client</Link>

              </label>
              <div className="flex ic gap6">
                {/* <input
                  className="fc"
                  value={projectform.clientName}
                  onChange={(e) => handleChange("clientName", e.target.value)}
                  style={{ flex: 1 }}
                /> */}

                <select
                  className="fs"
                  value={projectform.clientName}
                  onChange={(e) => handleChange("clientName", e.target.value)}
                >
                  <option value="">Select</option>
                  {clientList?.map((c) => (
                    <option value={c?.Id}>{c?.ClientName}</option>
                  ))}
                </select>
                {errors.clientName && (
                  <div className="invalid-feedback">{errors.clientName}</div>
                )}

                {/* {showClientDetails ? (
                  <button
                    type="button"
                    className="btn btn-ghost btn-sm"
                    onClick={toggleClientExpand}
                  >
                    Hide
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-ghost btn-sm"
                    onClick={toggleClientExpand}
                  >
                    Details
                  </button>
                )} */}
              </div>
            </div>

            <div>
              <label className="fl">Project Manager</label>
              <select
                className="fs"
                value={projectform.manager}
                onChange={(e) => handleChange("manager", e.target.value)}
              >
                <option value="">Select</option>
                {employeeList?.map((e) => (
                  <option key={e?.Id} value={e?.Id}>
                    {e?.FullName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Client Details */}
          {/* {showClientDetails && (
            <div className="client-box">
              <div className="frow fc2">
                <input
                  className="fc"
                  placeholder="Location"
                  onChange={(e) =>
                    handleChange("clientLocation", e.target.value)
                  }
                />
                <input
                  className="fc"
                  placeholder="Contact"
                  onChange={(e) =>
                    handleChange("clientContact", e.target.value)
                  }
                />
              </div>

              <div className="frow fc3">
                <input
                  className="fc"
                  placeholder="Email"
                  onChange={(e) => handleChange("clientEmail", e.target.value)}
                />
                {errors.clientEmail && (
                  <div className="invalid-feedback">{errors.clientEmail}</div>
                )}

                <input
                  className="fc"
                  placeholder="Phone"
                  onChange={(e) => handleChange("clientPhone", e.target.value)}
                />
                {errors.clientPhone && (
                  <div className="invalid-feedback">{errors.clientPhone}</div>
                )}

                <input
                  className="fc"
                  placeholder="Website"
                  onChange={(e) => handleChange("clientWeb", e.target.value)}
                />
              </div>
            </div>
          )} */}
          {/* <div className="form-check">
  
  <label className="form-check-label" for="flexCheckDefault">
    Is Active
  </label>
  <input className="form-check-input me-2" type="radio" name="flexRadioDefault" id="flexRadioDefault1"/>
  <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"/>
</div> */}
          <div className="form-check form-switch">
            <label className="form-check-label" for="flexSwitchCheckDefault">Is Private</label>
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" checked={!projectform?.IsPublic || false}
              onChange={(e) =>
                setProjectForm({
                  ...projectform,
                  IsPublic: !e.target.checked,
                })
              } />

          </div>
          {/* Description */}
          <div style={{ marginBottom: 12 }}>
            <label className="fl">Description</label>
            {/* <div
              className="wysiwyg-editor"
              contentEditable
              onInput={(e) =>
                handleChange("desc", e.currentTarget.innerHTML)
              }
              style={{ minHeight: 100 }}
            ></div> */}

            <Editor
              name="shortDesc"
              value={projectform.desc}
              onTextChange={(e) => {
                handleChange("desc", e.htmlValue);
              }}
              headerTemplate={headerTemplate}
              style={{ height: "150px" }}
            />
          </div>

          {/* Team */}
          <div>
            <label className="fl member-add-label">Team Members   <button className="member-add-btn"
              onClick={() => setShowEmployee(!showEmployee)}>
              <i
                className="fa-solid fa-plus"
                style={{ fontSize: "10px" }}
              ></i>{" "}
              Add member
            </button>
              {/* Dropdown */}
              {showEmployee && (
                <div className="member-dropdown open" id="memberDD">
                  {employeeList?.length > 0 && employeeList.map((e, index) => {
                    const initials = e.FullName?.split(" ")
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase();
                    const profileImg = e.ProfileImage;
                    const isChecked = projectform?.team?.some((t) => t.Id === e.Id);
                    return (
                      <div
                        key={e?.Id || index}
                        className="member-dd-item"
                        style={{
                          opacity: 1,
                          pointerEvents: 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(ev) => toggleMember(e, ev.target.checked)}
                          style={{ marginRight: 6 }}
                        />
                        {profileImg ? (
                          <img
                            src={profileImg}
                            alt={e?.FullName}
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: "50%",
                              objectFit: "cover",
                              background: "#EC4119",
                              display: "inline-block",
                            }}
                            title={e?.FullName}
                            onError={ev => { ev.target.onerror = null; ev.target.src = "/images/placeholder_profile.png"; }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: "50%",
                              background: "#EC4119",
                              color: "#fff",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 700,
                              fontSize: "8px",
                            }}
                            title={e?.FullName}
                          >
                            {initials}
                          </div>
                        )}
                        <span>{e?.FullName}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </label>

            <div className="team-frow">
              {/* Add Button */}

              {/* {projectform.team?.length === 0 && ( */}
              <div
                className="teams-chips"
              >
                {/* Selected Chips */}
                <div className="project-assign-team">
                  {visibleMembers?.map((member) => (
                    <div className="member-chip" key={member.Id}>
                      {member.FullName}
                      <span onClick={() => removeMember(member.Id)}>×</span>
                    </div>
                  ))}

                  {projectform.team?.length > 3 && (
                    <a
                      href="#"
                      className="viewmore-team"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAll(!showAll);
                      }}
                    >
                      {showAll ? "View Less" : "View More"}
                    </a>
                  )}
                </div>

              </div>
            </div>
            {/* )} */}


            {/* <div className="member-wrap">
              <div
                className="member-chips"
                onClick={toggleMemberDD}
              ></div>
              {showMemberDD && (
                <div className="member-dropdown">
                  <div>Select members...</div>
                </div>
              )}
            </div> */}
          </div>
        </div>

        {/* Footer */}
        <div className="mfoot">
          <button className="btn btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-brand"
            onClick={handleSave}
            disabled={isAnythingLoading}
          >
            {isAnythingLoading ? "Saving..." : "Save Project Details"}
          </button>
        </div>
      </div>

      {isAnythingLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default AddProject;
